/**
 * Created by seaasun on 2017/12/8.
 */
import order from '@/config/order'
export default order()



// WEBPACK FOOTER //
// ./src/store/order/state.js